<dx-scroll-view>
  <div class="py-2 pt-4 px-4">
    <h3 class="font-light border-b border-gray-300 mb-2">
      Parcelle {{intervention.field?.name || 'N/A'}} <span
      class="float-right text-base">{{intervention.start_time | date :'shortTime'}}
      - {{intervention.stop_time | date :'shortTime'}} ({{intervention.start_time | date :'shortDate'}})</span></h3>
    <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
      <div title="Superficie" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Totale</div>
        <span class="metric-value">{{intervention.field ? intervention.field.polygonAreaToHa().toFixed(2) : '-'}} <span
          class="metric-unit">Ha</span></span>
      </div>
      <div title="Superficie Travaillée" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Travaillée</div>
        <span class="metric-value">{{intervention.working_area_ha ? intervention.working_area_ha.toFixed(2) : '-'}} <span
          class="metric-unit">Ha</span></span>
      </div>
      <div title="Percentage" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Percentage</div>
        <span class="metric-value">{{intervention.working_area_percent ? (intervention.working_area_percent * 100).toFixed(1) : '-'}} <span
          class="metric-unit">%</span></span>
      </div>
      <div title="Débit" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Débit</div>
        <span class="metric-value">{{intervention.working_hectare_per_hour ? intervention.working_hectare_per_hour.toFixed(2) : '-'}} <span
          class="metric-unit">Ha/h</span></span>
      </div>
    </div>
  </div>

  <div class="py-2 px-4 pt-0">
    <h3 class="font-light border-b border-gray-300 mb-1"> Consomation Carburant </h3>
    <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
      <div title="Totale" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Totale</div>
        <span class="metric-value">{{intervention.metrics?.fuel_total_consumption_all ? (intervention.metrics.fuel_total_consumption_all | number) : '-'}} <span
          class="metric-unit">L</span></span>
      </div>
      <div title="Par Heure" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Par Heure</div>
        <span class="metric-value">{{intervention.metrics?.fuel_hourly_consumption_rate_avg_all ? (intervention.metrics.fuel_hourly_consumption_rate_avg_all | number) : '-'}} <span
          class="metric-unit">L/h</span></span>
      </div>
      <div title="Heures Moteurs" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Heures Moteurs</div>
        <span class="metric-value">{{intervention.metrics?.engine_working_hours_all ? (intervention.metrics.engine_working_hours_all | number) : '-'}} <span
          class="metric-unit">h</span></span>
      </div>
      <div title="Temperature" class="shadow-sm hover:shadow cursor-pointer">
        <div class="metric-text">Temperature</div>
        <span class="metric-value">{{intervention.metrics?.fuel_temperature_avg_all ? (intervention.metrics.fuel_temperature_avg_all | number) : '-'}} <span
          class="metric-unit">°C</span></span>
      </div>
    </div>
  </div>


  <div class="p-4 pt-0">
    <div class="grid grid-cols-2 gap-3">
      <div>
        <h3 class="font-light border-b border-gray-300 mb-2">Vitesse Travail</h3>
        <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
          <div title="Moyenne" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Moyenne</div>
            <span class="metric-value">{{intervention.working_in_field_speed_avg ? intervention.working_in_field_speed_avg.toFixed(2) : '-'}} <span
              class="metric-unit">Km/h</span></span>
          </div>
          <div title="Maximale" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Maximale</div>
            <span class="metric-value">{{intervention.working_in_field_speed_max ? intervention.working_in_field_speed_max.toFixed(2) : '-'}} <span
              class="metric-unit">Km/h</span></span>
          </div>
        </div>
        <h3 class="font-light border-b border-gray-300 mt-4 mb-2">Machines & Outils</h3>
        <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
          <div title="Tracteur" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Tracteur</div>
            <span class="metric-value">{{intervention.tractor_name}}</span>
          </div>
          <div title="Outil" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Outil</div>
            <span class="metric-value">{{intervention.trailer_name}}</span>
          </div>
          <div title="Largeur de Travail" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Largeur de Travail</div>
            <span class="metric-value">{{intervention.trailer_width ? (intervention.trailer_width / 100).toFixed(2) : '-'}} <span
              class="metric-unit">m</span></span>
          </div>
        </div>
      </div>
      <app-time-pie-chart title="Temps" [data]="timeReport"></app-time-pie-chart>
    </div>
  </div>
</dx-scroll-view>
